/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
  GetApiV1ExamRevisionBotexamidLangGridPathParams,
  GetApiV1ExamRevisionBotexamidLangGridQueryParams,
  GetApiV1ExamRevisionBotexamidLangGrid401,
  GetApiV1ExamRevisionBotexamidLangGrid404,
  GetApiV1ExamRevisionBotexamidLangGrid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamidLangGrid.ts";

function getGetApiV1ExamRevisionBotexamidLangGridUrl(
  botExamId: GetApiV1ExamRevisionBotexamidLangGridPathParams["botExamId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/revision/${botExamId}/lang/grid` as const,
  };
  return res;
}

/**
 * @description Retorna a lista paginada dos idiomas cadastrados para uma prova gerada por IA, ordenados por cultura. Cada item inclui código e nome do idioma, título, instrução, status e situação do registro. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas da prova gerada por IA no grid (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/:botExamId/lang/grid}
 */
export async function getApiV1ExamRevisionBotexamidLangGrid(
  botExamId: GetApiV1ExamRevisionBotexamidLangGridPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidLangGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamidLangGrid401
      | GetApiV1ExamRevisionBotexamidLangGrid404
      | GetApiV1ExamRevisionBotexamidLangGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamRevisionBotexamidLangGridUrl(botExamId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
